import Marquee from "react-fast-marquee";

const ITEMS = [
  "WE COME TO YOU",
  "NEWCASTLE & SURROUNDS",
  "OPEN 7 DAYS · 7AM–5PM",
  "5-STAR RATED",
  "PREMIUM DETAILING",
  "HAND WASH ONLY",
  "INTERIOR DEEP CLEAN",
];

export default function MarqueeBand() {
  return (
    <div
      data-testid="marquee-band"
      className="bg-black border-y border-white/10 py-5"
    >
      <Marquee gradient={false} speed={45} pauseOnHover>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl sm:text-3xl font-black uppercase tracking-tight text-[#E10600] mx-10 flex items-center gap-10"
          >
            {t}
            <span className="w-2 h-2 rounded-full bg-white/30" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
